import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-receipt-statement',
  templateUrl: './receipt-statement.component.html',
  styleUrls: ['./receipt-statement.component.css']
})
export class ReceiptStatementComponent implements OnInit {

  no = '';
  // customerList = [];
  cashAcctList = [];
  bankAcctList = [];

  // search_obj = {
  //   'placeholder': 'رقم العميل/ اسم العميل', 'class_name': 'longSearchField',
  //   'table_list': [
  //     {
  //       'table_name': '`customer`', 'selected_no': 'acct_number',
  //       'field_list': ['acct_number', 'customer_name', 'customer_name_en', 'mobile']
  //     }
  //   ]
  // };

  // search_cash = {
  //   'placeholder': 'رقم الحساب/ اسم الحساب', 'class_name': 'longSearchField',
  //   'table_list': [{
  //     'table_name': '`sub_acct`', 'selected_no': 'acct_number',
  //     'field_list': ['sub_acct_name', 'sub_acct_name_en', 'acct_number', 'emp_no'],
  //     'join_table': '`user`',
  //     'join_condition': " AND `user`.`acct_number` = `sub_acct`.`acct_number` AND `user`.`acct_number` != '' AND `user`.`is_counter` = '1'"
  //   }]
  // };

  // search_Bank = {
  //   'placeholder': 'رقم الحساب/ اسم الحساب', 'class_name': 'longSearchField',
  //   'table_list': [{
  //     'table_name': '`bank_account`', 'selected_no': 'acct_number',
  //     'field_list': ['acct_number', 'bank_acct_number', 'account_name', 'account_name_en']
  //   }]
  // };

  // search_casher = {
  //   'placeholder': 'رقم الحساب/ اسم الحساب', 'class_name': 'longField',
  //   'table_list': [{
  //     'table_name': '`sub_acct`', 'selected_no': 'acct_number',
  //     'field_list': ['sub_acct_name', 'sub_acct_name_en', 'acct_number', 'emp_no'],
  //     'condition': " AND `sub_acct`.`main_acct_no` = '101'"
  //   }]
  // };

  search_acct = {
    'placeholder': 'رقم الحساب/ اسم الحساب', 'class_name': 'longSearchField',
    'table_list': [{
      'table_name': '`sub_acct`', 'selected_no': 'acct_number',
      'field_list': ['acct_number', 'sub_acct_name', 'sub_acct_name_en'],
      'condition': " AND `sub_acct`.`is_leaf` = '1' AND `sub_acct`.`is_cc` = '1'"
    }]
  };

  model = {
    'table_name': 'cash_receipt', 'cash_receipt_id': '0', 'cash_receipt_no': '', 'receipt_no': 'RECEIPT',
    'no': '0', 'year': '', 'receipt_date': '', 'customer_no': '', 'acct_number': '', 'acct_name': '',
    'account_type': '', 'bank_name': '', 'check_no': '', 'to_acct': '', 'paid': '', 'payment_method': 'cash',
    'flag': 'new', 'key': 'cash_receipt_id', 'cost_center': '0', 'bank_account_no': '', 'comment': '',
    'branch_id': this.applicationConstants.user_branch_info.user_branch_id
  };

  data_model = { 'receiptDate': new Date() };

  search_obj = {
    'placeholder': 'اسم العميل/ رقم العميل/ رقم الجوال', 'class_name': 'longSearchField',
    'table_list': [{
      'table_name': '`customer`', 'selected_no': 'acct_number',
      'field_list': ['acct_number', 'customer_name', 'customer_name_en', 'mobile'],
      'condition': " AND `branch_id` = '" + this.model['branch_id'] + "'"
    }]
  };

  // from_acct = {
  //   sub_acct_name: "", sub_acct_name_en: "", sub_acct_id: '0', acct_number: '', mobile: '',
  //   account_type: ''
  // };

  cost_centers = [];
  accts = [];
  toDelete = [];
  count = 1;
  private dp = [{
    'id': this.count, 'check': '0', 'acct_number': '', 'acct_num_name': '', 'amount': '', 'flag': 'new', 'key': '',
    'rec_id': '0'
  }];
  displayedColumns = ['check', 'acct_number', 'amount'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;

  customer_detail = '';
  cash_detail = '';
  bank_detail = '';

  Success_Msg; Error_Msg; Acct_Placeholder;
  Name_Msg; Rec_Amount_Msg; Payment_Method_Msg;
  Casher_Acct_Msg; Bank_Acct_Msg; Rec_Total_Msg;
  Statement_No; Customer_Placeholder;
  // Name; 

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants, private route: ActivatedRoute,
    private queryList: QueryList, public translate: TranslateService, private router: Router) {
    this.getMessages(translate);
  }

  getMessages(translate) {
    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    // translate.get('Name').subscribe((res: string) => {
    //   this.Name = res;
    // });
    // this.search_obj['placeholder'] = this.Name;  

    translate.get('Customer_Placeholder').subscribe((res: string) => {
      this.Customer_Placeholder = res;
    });
    this.search_obj['placeholder'] = this.Customer_Placeholder;

    // translate.get('Acct_Placeholder').subscribe((res: string) => {
    //   this.Acct_Placeholder = res;
    // });
    // this.search_Bank['placeholder'] = this.Acct_Placeholder;
    // this.search_acct['placeholder'] = this.Acct_Placeholder;

    translate.get('Name_Msg').subscribe((res: string) => {
      this.Name_Msg = res;
    });

    translate.get('Rec_Amount_Msg').subscribe((res: string) => {
      this.Rec_Amount_Msg = res;
    });

    translate.get('Payment_Method_Msg').subscribe((res: string) => {
      this.Payment_Method_Msg = res;
    });

    translate.get('Casher_Acct_Msg').subscribe((res: string) => {
      this.Casher_Acct_Msg = res;
    });

    translate.get('Bank_Acct_Msg').subscribe((res: string) => {
      this.Bank_Acct_Msg = res;
    });

    translate.get('Rec_Total_Msg').subscribe((res: string) => {
      this.Rec_Total_Msg = res;
    });

    translate.get('Statement_No').subscribe((res: string) => {
      this.Statement_No = res;
    });
  }

  ngOnInit() {
    let obj;

    // get leaf customer accts
    // let branch_list = [{ 'branch_id': this.model['branch_id'] }];
    // let parent_acct = this.applicationConstants.main_acct_config['customer'];
    // obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: true, only_leaf: true, 
    //   type: 'customer', branch_list: branch_list };

    // this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
    //   .subscribe(data => {
    //     this.applicationConstants.appComp.hideBusyCursor();
    //     this.customerList = data.data['list'];
    //   });

    // get leaf cashier accts
    let parent_acct = this.applicationConstants.main_acct_config['cash'];
    obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: true, only_leaf: true };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.cashAcctList = data.data['list'];
      });

    // get leaf bank accts
    parent_acct = this.applicationConstants.main_acct_config['bank'];
    obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: true, only_leaf: true };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.bankAcctList = data.data['list'];
      });

    let query = this.queryList.all_costCenter;
    obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.cost_centers = data.data['list'];

        let costObj = { 'cc_id': '0', 'cc_number': '0', 'cc_name': 'الرئيسي', 'cc_name_en': 'Main' };
        this.cost_centers.unshift(costObj);
      });

    this.route.params.subscribe(params => {
      if (params['no'] != undefined) {
        this.no = params['no'];

        // get receipt statement detail
        query = "SELECT `cash_receipt`.*, `sub_acct`.`sub_acct_name`, `sub_acct`.`sub_acct_name_en`, " +
          "`customer`.`customer_name`, `customer`.`customer_name_en`, `customer`.`mobile` FROM `cash_receipt`, `sub_acct`, `customer` " +
          "WHERE `cash_receipt`.`cash_receipt_no` = '" + this.no + "' AND " +
          "`cash_receipt`.`customer_no` = `customer`.`acct_number` AND `cash_receipt`.`to_acct` = `sub_acct`.`acct_number`";
        console.log(query);
        obj = { cmd: 'getList', query: query };
        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();

            let result = data.data['list'][0];
            console.log(result);
            this.model['cash_receipt_id'] = result['cash_receipt_id'];
            this.model['cash_receipt_no'] = result['cash_receipt_no'];
            this.model['no'] = result['no'];
            this.model['receipt_date'] = result['receipt_date'];
            this.data_model['receiptDate'] = new Date(result['receipt_date']);
            this.model['customer_no'] = result['customer_no'];

            this.customer_detail = result['customer_no'] + '-' + result['customer_name'] + '-' + 
              result['customer_name_en'];
            // (document.getElementById('search_value_0') as HTMLInputElement).value = result['customer_name'] + '-' +
            //   result['customer_name_en'] + '-' + result['customer_no'];

            this.model['bank_name'] = result['bank_name'];
            this.model['check_no'] = result['check_no'];
            this.model['paid'] = result['paid'];
            this.model['payment_method'] = result['payment_method'];
            this.model['to_acct'] = result['to_acct'];
            console.log(result['payment_method']);
            if (this.model['payment_method'] == 'cash')
              this.cash_detail = result['sub_acct_name'] + '-' + result['sub_acct_name_en'] + '-' + 
                result['to_acct'];
              // (document.getElementById('search_value_10000') as HTMLInputElement).value = result['sub_acct_name'] + '-' +
              //   result['sub_acct_name_en'] + '-' + result['to_acct'];
            else
              this.bank_detail = result['sub_acct_name'] + '-' + result['sub_acct_name_en'] + '-' + 
                result['to_acct'];
              // (document.getElementById('search_value_20000') as HTMLInputElement).value = result['sub_acct_name'] + '-' +
              //   result['sub_acct_name_en'] + '-' + result['to_acct'];

            this.model['flag'] = 'update';
            this.model['cost_center'] = result['cost_center'];
            this.model['bank_account_no'] = result['bank_account_no'];
            this.model['comment'] = result['comment'];
            this.model['branch_id'] = result['branch_id'];
            console.log(this.model);

            // get acct
            query = "SELECT `cash_receipt_acct`.*, `sub_acct`.`sub_acct_name`, `sub_acct`.`sub_acct_name_en` FROM " +
              "`cash_receipt_acct`, `sub_acct` WHERE `cash_receipt_acct`.`cash_receipt_no` = '" + this.no +
              "' AND `cash_receipt_acct`.`status` = '1' AND `cash_receipt_acct`.`type` = 'from' AND " +
              "`cash_receipt_acct`.`acct_number` = `sub_acct`.`acct_number`";
            console.log(query);
            obj = { cmd: 'getList', query: query };
            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();

                let acct_list = data.data['list'];
                if (acct_list.length > 0) {
                  this.dp = [];

                  acct_list.forEach(acct => {
                    this.dp.push({
                      'id': this.count, 'check': '0', 'acct_number': acct.acct_number,
                      'acct_num_name': acct.sub_acct_name + '-' + acct.sub_acct_name_en + '-' + acct.acct_number,
                      'rec_id': acct['receipt_acct_id'], 'amount': acct.amount, 'flag': 'none',
                      'key': 'receipt_acct_id'
                    });
                    this.count++;
                  });

                  this.dataSource = new MatTableDataSource(this.dp);
                  this.dataSource.sort = this.sort;
                }
              })
          });
      }
    });
  }

  // onChangeSearch = function (acct_number: string) {
  onChangeSearch = function (search_result: object) {
    // }
    console.log(search_result['no']);
    this.model['customer_no'] = search_result['no']; // search_result['no'];
    // this.from_acct.acct_number = search_result['no'];

    // if (this.from_acct.acct_number != '') {
    //   this.from_acct.sub_acct_name = (document.getElementById('search_value_0') as HTMLInputElement).value;
    //   this.from_acct.account_type = 'customer';
    // }
  }

  onChangeCashSearch = function (acct_number: string) {
    this.model['to_acct'] = acct_number; // search_result['no'];
    //this.model['acct_name'] = (document.getElementById('search_value_10000') as HTMLInputElement).value;
    this.model['account_type'] = 'cashier';
  }

  onChangeBankSearch = function (acct_number: string) {
    this.model['bank_account_no'] = acct_number; // search_result['no'];
    this.model['to_acct'] = acct_number; // search_result['no'];
    //this.model['acct_name'] = (document.getElementById('search_value_20000') as HTMLInputElement).value;
    this.model['account_type'] = 'bank';
  }

  onChangeAcct = function (search_result: object) {
    this.accts.push(search_result);
    // if (search_result['no'] != '')
    (document.getElementById('acct_number_' + search_result['row_id']) as HTMLInputElement).value = search_result['no'];

    let rec_id = document.getElementById('rec_id_' + search_result['row_id']) as HTMLInputElement;
    let flag = document.getElementById('flag_' + search_result['row_id']) as HTMLInputElement;
    //if the mode is edit and the record already there and need to be updated
    if (rec_id.value != '' && rec_id.value != '0') {
      if (flag.value == "none")
        (document.getElementById('flag_' + search_result['row_id']) as HTMLInputElement).value = 'update';
    }
  }

  change_amount(row) {
    if (this.model['flag'] == 'update') {
      if (row.flag != 'new')
        (document.getElementById('flag_' + row.id) as HTMLInputElement).value = 'update';
    }
  }

  addLine() {
    this.count++;
    this.dp.push({
      'id': this.count, 'check': '', 'acct_number': '', 'acct_num_name': '', 'amount': '', 'flag': 'new', 'key': '',
      'rec_id': '0'
    });
    this.dataSource = new MatTableDataSource(this.dp);
    this.dataSource.sort = this.sort;
  }

  delLine() {
    let count = 0;
    for (let index = (this.dp.length - 1); index >= 0; index--) {
      let id = this.dp[index]['id'];
      let check = document.getElementById('check_' + id) as HTMLInputElement;
      let flag = document.getElementById('flag_' + id) as HTMLInputElement;
      if (check.checked == true) {
        if (flag.value != '' && flag.value != undefined && flag.value != 'new') {
          this.toDelete.push(this.dp[index]);
        }
        this.dp.splice(index, 1);
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
        count++;
      }
    }
  }

  add() {
    let total_amount = 0;

    this.dp.forEach(element => {
      let amount = document.getElementById('amount_' + element.id) as HTMLInputElement;
      if (amount.value != '')
        total_amount += Number(amount.value);
    });

    if (this.model['customer_no'] == '') {
      alert(this.Name_Msg);
      return;
    }

    if (this.model['paid'] == '' || Number(this.model['paid']) == 0) {
      alert(this.Rec_Amount_Msg);
      return;
    }

    if (this.model['payment_method'] == '') {
      alert(this.Payment_Method_Msg);
      return;
    }

    if (this.model['payment_method'] == 'cash' && this.model['to_acct'] == '') {
      alert(this.Casher_Acct_Msg);
      return;
    }

    if (this.model['payment_method'] != 'cash' && this.model['bank_account_no'] == '') {
      alert(this.Bank_Acct_Msg);
      return;
    }

    if (Number(this.model['paid']) != total_amount) {
      alert(this.Rec_Total_Msg);
      return;
    }

    let values = [];

    this.model['receipt_date'] = (this.data_model['receiptDate'].getFullYear() + "-" +
      (this.data_model['receiptDate'].getMonth() + 1) + "-" + this.data_model['receiptDate'].getDate() + ' ' +
      (new Date()).getHours() + ':' + (new Date()).getMinutes() + ':' + (new Date()).getSeconds());

    let year;
    if (this.model['cash_receipt_id'] == '0') {
      year = this.data_model['receiptDate'].getFullYear();
      this.model['year'] = year.toString();
    }
    values.push(this.model);

    this.dp.forEach(element => {
      let amount = document.getElementById('amount_' + element.id) as HTMLInputElement;
      let flag = document.getElementById('flag_' + element.id) as HTMLInputElement;
      let acct_number = document.getElementById('acct_number_' + element.id) as HTMLInputElement;

      if (Number(amount.value) > 0 || (Number(amount.value) == 0 && element.rec_id != '0')) {
        if (Number(amount.value) == 0 && element.rec_id != '0')
          flag.value = 'delete';

        values.push({
          'table_name': 'cash_receipt_acct', 'cash_receipt_no': this.model['cash_receipt_no'],
          'receipt_acct_id': element.rec_id, 'flag': flag.value, 'key': 'receipt_acct_id',
          'acct_number': acct_number.value, 'amount': amount.value, type: 'from'
        });
      }
    });

    let obj;
    if (this.model['cash_receipt_id'] != '0') {
      this.toDelete.forEach(delElem => {
        values.push({
          'table_name': 'cash_receipt_acct',
          'receipt_acct_id': delElem.rec_id, 'flag': 'delete', 'key': 'receipt_acct_id',
          'cash_receipt_no': this.model['cash_receipt_no'], 'acct_number': delElem.acct_number, 'amount': '0'
        });
      });

      obj = { cmd: 'updateAdv', values: values };
    }
    else {
      let idWhere = " WHERE `year` = '" + year + "' AND `branch_id` = '" + 
        this.applicationConstants.user_branch_info.user_branch_id + "'";
      let prefix = this.applicationConstants.user_branch_info.user_branch_id + '-' + year + '-';

      obj = {
        cmd: 'add', values: values, pk: 'cash_receipt_no', id: 'no', main_table: 'cash_receipt',
        prefix: prefix, idWhere: idWhere
      };
    }

    console.log(obj);
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        if (data.status['type'] == 'success') {

          if (this.model['cash_receipt_id'] == '0')
            this.model['cash_receipt_no'] = data.status['msg']['0']['number'];

          alert(this.Success_Msg + ', ' + this.Statement_No + ': ' + this.model['cash_receipt_no']);
          this.router.navigate(['sub_menu/3/statement_list']);
          window.open(this.applicationConstants.statementPrint + "?receipt_no=" + this.model['cash_receipt_no'], "_blank");
        }
        else
          alert(this.Error_Msg);
      });
  }

}
